<template>
  <v-navigation-drawer
    app
    :clipped="clipped"
    :width="width"
    :color="color"
    v-model="drawer"
  >
    <slot name="preMenu"/>
    <v-list nav>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        :to="item.route"
        @click="item.clickHandler ? item.clickHandler() : noop()"
        :class="{'pl-9': !item.items, 'pl-0': item.items}"
        :id="item.id"
      >
        <v-row v-if="!item.items" class="pl-3">
          <v-list-item-icon>
            <v-icon size="28" :class="{'material-icons-outlined':item.iconOutlined}">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-row>
        <v-row v-if="item.items">
          <v-expansion-panels
              accordion
              flat
          >
            <v-expansion-panel>
              <v-expansion-panel-header class="pt-0 pb-0">
                <v-row class="pl-9">
                  <v-list-item-icon>
                    <v-icon size="28" :class="{'material-icons-outlined':item.iconOutlined}">{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pl-10">
                <v-list nav>
                  <v-list-item
                    v-for="subItem in item.items"
                    :key="subItem.title"
                    :to="subItem.route"
                    @click="subItem.clickHandler ? subItem.clickHandler() : noop()"
                    >
                    <div class="pl-9">&nbsp;</div>
                    <v-list-item-content class="pl-6">
                      {{subItem.title}}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-list-item>
    </v-list>
    <slot name="postMenu"/>
  </v-navigation-drawer>
</template>

<script>
  export default {
    name: "NavigationDrawer",
    props: {
      color: {
        type: String,
        default: '#FFFFFF'
      },
      width: {
        type: String,
        default: '300'
      },
      clipped: {
        type: Boolean,
        default: true
      },
      items: {
        type: Array,
      }
    },
    data() {
      return {
        drawer: null
      };
    },
    created() {
      this.$eventHub.$on('toggleNavigationDrawer', this.toggleNavigationDrawer);
    },
    methods: {
      toggleNavigationDrawer() {
        this.drawer = !this.drawer;
      },
      noop() {
        return;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .v-list-item--active {
    border-left: 4px solid #041E42;
    background-color: #E3EEF7;
    &:before {
      opacity: 0;
    }
  }

  ::v-deep .v-expansion-panel-content__wrap {
    padding: 0px;
  }

  .v-navigation-drawer.theme--light .v-list .v-list-item {
    color: #041E42 !important;
    min-height: 64px;
    border-radius: 0px;
    &:before {
      opacity: 0;
    }
  }

  .v-item-group.v-expansion-panels {
    padding-left: 1px;
    z-index: 0;
    border-radius: 0px;
  }

  .v-item-group .v-expansion-panel .v-expansion-panel-header:hover {
    background-color: #D3E1F2;
  }

  .theme--light.v-icon {
    color: #041E42 !important;
    margin-top: 3px;
  }

  .v-navigation-drawer.theme--light .v-list {
    padding: 0;
    .v-list-item.v-list-item--link:hover {
      background-color: #D3E1F2;
    }
  }
</style>
